import React from "react";
import { ProjectTabsProps } from "@shared/interfaces/ProjectsFiles";

const ProjectsTabs: React.FC<ProjectTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="flex justify-between h-[65px] 2xl:h-[70px]">
      <div className="flex items-end space-x-4">
        <button
          className={`pb-5 px-2 text-sm 2xl:text-base text-center font-medium border-b-[3px] ${
            activeTab === "shared"
              ? " border-b-[3px] border-[#0357C9]"
              : "text-gray-400 border-transparent"
          }`}
          onClick={() => setActiveTab("shared")}
        >
          Shared with me
        </button>
        <button
          className={`pb-5 px-2 text-sm 2xl:text-base text-center font-medium border-b-[3px] ${
            activeTab === "private"
              ? " border-b-[3px] border-[#0357C9]"
              : "text-gray-400 border-transparent"
          } `}
          onClick={() => setActiveTab("private")}
        >
          My Projects
        </button>
      </div>
    </div>
  );
};

export default ProjectsTabs;
